var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"rounded":"","height":"27","color":"#ff9c00","depressed":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"assistant link"},[_vm._v(_vm._s(_vm.$t('pages.popup.upgrade.sub')))])])}
var staticRenderFns = []

export { render, staticRenderFns }